export default {
  app: {
    name: '医影IM'
  },
  init: {
    loading: '正在初始化...',
    connecting: '连接服务中...',
    loginIM: '登录通讯服务...',
    subtitle: '即时通讯',
    footer: '安全加密的即时通讯服务',
    error: {
      noToken: '链接已失效，请重新获取',
      sigFail: '获取签名失败，请重试',
      loginFail: '登录失败：{msg}',
      retry: '重试',
      hint: '请检查网络连接后重试'
    }
  },
  permission: {
    title: '检测到权限未开启',
    desc: '为保证正常通话，请点击下方按钮，然后在浏览器弹出权限提示时选择"允许"',
    openBtn: '去开启权限',
    skipBtn: '暂不需要',
    deniedTitle: '请开启麦克风/摄像头权限',
    deniedDesc: '请在浏览器设置中开启权限，然后重试',
    deniedStep1: '方法一（推荐）：点击浏览器地址栏左侧的锁定图标 🔒',
    deniedStep2: '→ 权限 → 麦克风/摄像头 → 设为"允许"',
    deniedStep3: '方法二：打开浏览器设置 → 隐私与安全 → 找到麦克风/摄像头权限并允许',
    deniedBtn: '重试'
  },
  conversation: {
    title: '消息',
    empty: '暂无会话',
    online: '在线',
    offline: '离线',
    connecting: '连接中',
    user: '用户',
    lastMsg: {
      image: '[图片]',
      audio: '[语音]',
      video: '[视频]',
      file: '[文件]',
      face: '[表情]',
      custom: '[消息]',
      calling: '[通话]',
      recall: '消息已撤回'
    }
  },
  chat: {
    placeholder: '说点什么...',
    send: '发送',
    recall: '撤回消息',
    recallSuccess: '消息已撤回',
    recallFail: '撤回失败，超出时间限制',
    copyText: '复制',
    deleteMsg: '删除',
    loadMore: '加载更多',
    noMore: '没有更多消息了',
    inputPlaceholder: '输入消息...',
    calling: '[视频通话]',
    callEnd: '通话结束',
    callDuration: '通话时长 {duration}',
    callConnected: '通话已接通',
    callMissed: '未接听',
    callCancelled: '已挂断',
    callRejected: '已拒绝',
    imagePreview: '图片预览',
    downloadFile: '下载文件',
    voiceSeconds: '{sec}秒',
    customLink: '查看详情',
    survey: '评分',
    holdToSpeak: '长按说话',
    releaseToSend: '松开发送',
    releaseToCancel: '上划取消',
    durationSecond: '{count}秒'
  },
  call: {
    incomingVideo: '视频通话',
    incomingAudio: '语音通话',
    calling: '正在呼叫...',
    callingUser: '正在呼叫 {name}...',
    incomingFrom: '{name} 来电话了',
    incomingVideoFrom: '{name} 发起视频通话',
    incomingAudioFrom: '{name} 发起语音通话',
    connecting: '正在接通...',
    accept: '接听',
    reject: '拒绝',
    hangup: '挂断',
    mute: '静音',
    unmute: '取消静音',
    camera: '摄像头',
    switchCamera: '翻转',
    speaker: '扬声器',
    timeout: '对方无应答',
    busy: '对方正在通话中',
    callRejected: '对方已拒绝',
    ended: '通话已结束',
    duration: '通话时长 {duration}',
    failed: '通话失败',
    permissionDenied: '请允许摄像头和麦克风权限',
    networkError: '网络不稳定',
    videoCall: '[视频通话]',
    audioCall: '[语音通话]'
  },
  common: {
    confirm: '确认',
    cancel: '取消',
    back: '返回',
    loading: '加载中...',
    networkError: '网络错误，请检查连接',
    unknownError: '发生未知错误',
    today: '今天',
    yesterday: '昨天'
  },
  error: {
    expired: '链接已过期',
    kicked: '您已在其他设备登录',
    noauth: '请从正确入口进入',
    somethingWrong: '出了点问题',
    expiredDesc: '请重新获取访问链接',
    kickedDesc: '您的账号已在其他设备登录，当前会话已断开',
    noauthDesc: 'URL 中缺少必要的 token，请重新扫码或获取链接'
  },
  message: {
    unknownFile: '未知文件',
    unsupportedMsg: '[不支持的消息类型]',
    viewDetail: '查看详情',
    sessionCreated: '已创建会话',
    systemMsg: '[系统消息]',
    sendFailed: '发送失败，请重试',
    imageSendFailed: '图片发送失败，请重试',
    roomInvalid: '房间信息无效'
  }
}
